import React from "react";
import EditorShell from "../EditorShell";
import { TextField, TextareaField } from "../fields";
import StringListEditor from "../StringListEditor";
import { whatThisIsSchema, SECTION_DEFAULTS } from "../schemas";

const WhatThisIsEditor = ({ section, onSaved, onLiveChange }) => (
  <EditorShell
    sectionKey="what_this_is"
    schema={whatThisIsSchema}
    defaults={SECTION_DEFAULTS.what_this_is}
    section={section}
    onSaved={onSaved}
    onLiveChange={onLiveChange}
  >
    {(form) => (
      <>
        <TextField form={form} path="title" label="Section title" />
        <TextareaField
          form={form}
          path="description"
          label="Description"
          required
          rows={4}
        />
        <StringListEditor
          form={form}
          name="pill_chips"
          label="Pill chips"
          placeholder="Voice, Text, Coaching…"
          max={10}
          hint='Known chips like "Voice" and "Text" render with matching icons; others render as plain pills.'
        />
      </>
    )}
  </EditorShell>
);

export default WhatThisIsEditor;
